import { render, staticRenderFns } from "./PayrollEnquiryDetail.vue?vue&type=template&id=13183120&scoped=true"
import script from "./PayrollEnquiryDetail.vue?vue&type=script&lang=js"
export * from "./PayrollEnquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./PayrollEnquiryDetail.vue?vue&type=style&index=0&id=13183120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13183120",
  null
  
)

export default component.exports